import ChapterBadge from "./ChapterBadge";
import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

const WhyLeadershipLoseSpeed = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const statements = [
    {
      text: "Leaders spend too much time gathering context before they can decide.",
    },
    {
      text: "Critical information is spread across systems, reports, documents, and people.",
    },
    {
      text: "What slows decisions is rarely lack of data — it is lack of trusted, usable context.",
    },
  ];

  return (
    <section 
      ref={ref}
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24 relative"
      data-testid="why-leadership-section"
    >
      <div className="relative z-10 max-w-5xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <ChapterBadge number="02" name="Impediment" />
          <span className="mono-label">The Problem</span>
          <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white font-['Outfit']">
            Why leadership teams <span className="gradient-text">lose speed</span>
          </h2>
          <p className="mt-6 text-[#A1A1AA] max-w-2xl mx-auto text-base md:text-lg leading-relaxed">
            Executives lose time because information is fragmented, context is weak, and decision 
            support remains manual. OnTenacity uses AI to synthesize the strongest enterprise signals 
            into faster, more usable leadership intelligence.
          </p>
        </motion.div>

        {/* Statement Cards */}
        <div className="space-y-6">
          {statements.map((statement, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="p-8 md:p-10 rounded-2xl bg-[#0A0A0B] border border-white/5 hover:border-white/10 transition-colors"
              data-testid={`statement-card-${index + 1}`}
            >
              <p className="text-xl md:text-2xl text-white font-['Outfit'] font-medium leading-relaxed">
                {statement.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyLeadershipLoseSpeed;
